import { Fragment, useEffect, useRef, useState } from "react";
import {
  Button,
  ConfigProvider,
  Form,
  Input,
  InputNumber,
  Space,
  Switch,
  notification,
  Checkbox,
} from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { useShowBoxContext } from "../../context/boxRestaurantContext";
import type { NotificationPlacement } from "antd/es/notification/interface";
import plusIcon from "../../icons/plusIcon.svg";
import { LoadingOutlined } from "@ant-design/icons";
import {
  listProductRestaurant,
} from "../../services/products";
import { UploadFile } from "../../services/file";
import React from "react";
import { updateDeal, updateDealStatus } from "../../services/deal";

export default function DealEditComponent({
  productSelect,
}: {
  productSelect: any;
}) {
  const [itemImage, setItemImage] = useState<any>(null);
  const days = [
    { value: 1, label: "Segunda-feira" },
    { value: 2, label: "Terça-feira" },
    { value: 3, label: "Quarta-feira" },
    { value: 4, label: "Quinta-feira" },
    { value: 5, label: "Sexta-feira" },
    { value: 6, label: "Sábado" },
    { value: 7, label: "Domingo" },
  ];
  const [itemImageLoading, setItemImageLoading] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [isBlocked, setIsBlocked] = useState<boolean>(false);
  const [Formins] = Form.useForm();
  const [weekday, setWeekday] = useState(
    Formins.getFieldValue("weekday") || []
  );
  const [currentStatus, setCurrentStatus] = useState("active");
  const [api, contextHolder] = notification.useNotification();
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const fileInputleRef = useRef(null);

  const openNotificationError = (placement: NotificationPlacement) => {
    api.error({
      message: `Operação fracassada`,
      description: `Por favor, verifique as informações inseridas`,
      placement,
      duration: 3,
    });
  };
  const openNotificationSuccess = (
    placement: NotificationPlacement,
    values: any
  ) => {
    api.success({
      message: `Operação concluída com sucesso!`,
      description: `${values.name} foi modificado com sucesso`,
      placement,
      duration: 3.5,
    });
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const stylesInput = {
    borderColor: "#6A2A40",
  };

  useEffect(() => {
    Formins.setFieldsValue(productSelect);
    setItemImage(productSelect.picture);
  }, [productSelect, Formins]);
  const onFinish = async (values: any) => {
    const data = {
      name: values.name,
      picture: values.picture,
      collibri_id: values.collibri_id,
      weekday: weekday,
      status: currentStatus,
      start: values.start,
      end: values.end,
      deal_compositions: values.deal_compositions.map((item: any) => ({
        price: item.price,
        product_id: item.id,
      })),
    };
    updateDeal({ dealId: productSelect.id, requestBody: data }).then((resp) => {
      setIsBlocked(true);
      openNotificationSuccess("top", resp);
    });
  };

  const handleSwitchChange = async (checked: boolean) => {
    const newStatus = checked ? "active" : "inactive";
    setCurrentStatus(newStatus);

    try {
      const resp = await updateDealStatus({ dealId: productSelect.id, status: newStatus });
      openNotificationSuccess("top", resp);
    } catch (error) {
      console.error("Erro ao atualizar status", error);
    }
  };


  const onFinishFailed = (errorInfo: any) => {
    openNotificationError("top");
  };

  function loadProducts() {
    listProductRestaurant({ limit: 1000, offset: 0, type: "regular" }).then(
      (resp) => {
        setProducts(resp.items);
        console.log("resp.items", resp.items);
      }
    );
  }
  function validatedOptionDisabled(item: any) {
    const complements = Formins.getFieldValue("complements") || [];
    const additionals = Formins.getFieldValue("additionals") || [];
    const items = [...complements, ...additionals];
    const filtered =
      items.filter((product: any) => product.id === item.id).length > 0;
    return filtered;
  }

  useEffect(() => {
    loadProducts();
  }, []);

  useEffect(() => {
    const currentWeekday = Formins.getFieldValue("weekday");
    const currentStatus = Formins.getFieldValue("status");
    setCurrentStatus(currentStatus);
    if (currentStatus === "inactive") {
      setIsBlocked(true);
    }
    console.log("Atualizando weekday em Formins:", currentWeekday);
    setWeekday(currentWeekday || []);
  }, [Formins.getFieldValue("weekday")]);

  const handleCheckboxChange = (value: any, checked: boolean) => {
    let next;

    if (checked) {
      next = [...weekday, value];
    } else {
      next = weekday.filter((item: any) => item !== value);
    }

    setWeekday(next);
  };

  const onChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    console.log("selectedValue productSelect", selectedValue);

    const selectedProduct = products.find(
      (product) => product.id === parseInt(selectedValue)
    );
    if (selectedProduct) {
      Formins.setFieldsValue({
        deal_compositions: [
          ...Formins.getFieldValue("deal_compositions"),
          selectedProduct,
        ],
      });
      setSelectedProduct(selectedValue);
    }
  };

  function handleUploadImageProfile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setItemImage(null);
      setItemImageLoading(true);

      UploadFile({ file: selectedFile })
        .then((response) => {
          const imageUrl = response.path || response.data.path;
          if (!imageUrl) {
            throw new Error("Erro ao obter o caminho da imagem");
          }

          setItemImage(imageUrl);
          Formins.setFieldsValue({ picture: imageUrl });
          setItemImageLoading(false);
        })
        .catch((error) => {
          console.error("Erro ao fazer upload da imagem:", error);
          setItemImageLoading(false);
        });
    }
  }
  return (
    <>
      <h3>Editar Promoção</h3>
      {contextHolder}
      <Form.Provider>
        <Form
          name="basic"
          onFinish={onFinish}
          form={Formins}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          disabled={isBlocked}
        >
          <Form.Item
            name="picture"
            label="Imagem do Item"
            rules={[
              { required: false, message: "Por favor, carregue uma imagem" },
            ]}
          >
            <div
              style={{
                display: "flex",
                borderRadius: 20,
                border: "3px dotted #6A2A40",
                width: "350px",
                justifyContent: "center",
                alignItems: "center",
                height: "250px",
                padding: "5px",
                cursor: "pointer",
              }}
              //@ts-ignore
              onClick={() => fileInputleRef.current.click()}
            >
              {itemImage ? (
                <>
                  <img
                    src={itemImage}
                    alt="imagem do produto"
                    className="image-profile"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      borderRadius: 20,
                    }}
                  />
                </>
              ) : (
                <>
                  {itemImageLoading ? (
                    <LoadingOutlined rev={undefined} />
                  ) : (
                    <h2
                      style={{
                        minWidth: "100%",
                        minHeight: "100%",
                        borderRadius: 20,
                        background: "#6A2A40",
                        marginBottom: 20,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Upload imagem
                    </h2>
                  )}
                </>
              )}
            </div>
            <input
              type="file"
              onChange={handleUploadImageProfile}
              ref={fileInputleRef}
              style={{ display: "none" }}
            />
          </Form.Item>
          <Form.Item
            label="Nome"
            name="name"
            rules={[{ required: true, message: "Inserir o nome do produto" }]}
          >
            <Input style={stylesInput} />
          </Form.Item>
          <Form.Item
            label="Codigo"
            name="collibri_id"
            rules={[
              {
                required: false,
                message: "Inserir o código colibri do produto",
              },
            ]}
          >
            <Input style={stylesInput} />
          </Form.Item>
          <div>
            <strong>PRODUTOS:</strong>
          </div>
          <Form.List name="deal_compositions">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...field }, index) => (
                  <Space key={key} align="baseline" style={{ display: "flex" }}>
                    <Form.Item
                      {...field}
                      name={[name, "name"]}
                      label="Nome"
                      rules={[
                        {
                          required: true,
                          message: "Adicione o nome do complemento",
                        },
                      ]}
                    >
                      <Input readOnly />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[name, "price"]}
                      label="Preço"
                      rules={[
                        {
                          required: false,
                          message: "Adicione o preço do produto",
                        },
                      ]}
                    >
                      <InputNumber
                        style={stylesInput}
                        step="0.01"
                        prefix="R$"
                        formatter={(value) => `${value}`.replace(",", ".")}
                        parser={(value) => value!.replace(",", ".")}
                      />
                    </Form.Item>
                  </Space>
                ))}
              </>
            )}
          </Form.List>
          <>
            {!isBlocked ? (
              <div
                className="create_product_form_dropdown_box"
                style={{ margin: "30px" }}
              >
                <select
                  id="dropdown"
                  onChange={(event) => onChangeSelect(event)}
                  value={selectedProduct}
                >
                  <option value="">Selecione um produto para vincular</option>
                  {products.map((product) => {
                    const disabled = validatedOptionDisabled(product);
                    return (
                      <option
                        key={product.id}
                        value={product.id}
                        disabled={disabled}
                      >
                        {product.name}
                      </option>
                    );
                  })}
                </select>

                <button
                  type="button"
                  onClick={() => {}}
                  className="button_products"
                >
                  <img src={plusIcon} alt="" />
                </button>
              </div>
            ) : (
              <div></div>
            )}
          </>

          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#6A2A40",
                fontSize: 15,
                fontSizeSM: 15,
              },
            }}
          >
            <Form.Item name={"status"} label="Status">
              <Switch
                checked={currentStatus === "active"}
                checkedChildren="Ativo"
                unCheckedChildren="Inativo"
                onChange={handleSwitchChange}
              />
            </Form.Item>
          </ConfigProvider>
          <Form.Item label="Disponibilidade por dia:">
            <div
              style={{
                gap: 2,
                display: "felx",
                justifyContent: "center",
                alignItems: "center",
                maxWidth: "450px",
              }}
            >
              {days.map((day) => (
                <Space key={day.label} align="baseline" style={{ padding: 5 }}>
                  <Checkbox
                    checked={weekday.includes(day.value)}
                    onChange={(e) => {
                      handleCheckboxChange(day.value, e.target.checked);
                    }}
                  />
                  {day.label}
                </Space>
              ))}
            </div>
          </Form.Item>
          <Form.Item
            label="Disponibilidade por horário:"
            style={{ display: "flex", gap: "5px"}}
          >
            <Form.Item
              name="start"
              label="Início"
              rules={[
                {
                  required: true,
                  message: "Por favor, selecione o horário de início!",
                },
              ]}
              style={{ display: "inline-block", width: "calc(50%)", marginRight: "10px" }}
            >
              <Input type="time" step="1" placeholder="Início" />
            </Form.Item>

            <Form.Item
              name="end"
              label="Fim"
              rules={[
                {
                  required: true,
                  message: "Por favor, selecione o horário de fim!",
                },
              ]}
              style={{ display: "inline-block", width: "calc(50%)" }}
            >
              <Input type="time" step="1" placeholder="Fim" />
            </Form.Item>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8 }}>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#6A2A40",
                  fontSize: 18,
                  fontSizeSM: 20,
                  borderRadius: 20,
                  paddingContentHorizontal: 70,
                },
              }}
            >
              <Button loading={loading} type="primary" htmlType="submit">
                Salvar alterações
              </Button>
            </ConfigProvider>
          </Form.Item>
        </Form>
      </Form.Provider>
    </>
  );
}
